export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00040.5cc10fc0.png";